import React, { Component, Fragment } from 'react';
import {
  PERMUTIVE_PROJECT_ID,
  PERMUTIVE_API_KEY
} from 'constants/ads/permutive';

const PERMUTIVE_JS = `
!function(n,e,o,r,i){if(!e){e=e||{},window.permutive=e,e.q=[],e.config=i||{},e.config.projectId=o,e.config.apiKey=r,e.config.environment=e.config.environment||"production";for(var t=["addon","identify","track","trigger","query","segment","segments","ready","on","once","user","consent"],c=0;c<t.length;c++){var f=t[c];e[f]=function(n){return function(){var o=Array.prototype.slice.call(arguments,0);e.q.push({functionName:n,arguments:o})}}(f)}}}(document,window.permutive,"${PERMUTIVE_PROJECT_ID}","${PERMUTIVE_API_KEY}",{});
window.googletag=window.googletag||{},window.googletag.cmd=window.googletag.cmd||[],window.googletag.cmd.push(function(){if(0===window.googletag.pubads().getTargeting("permutive").length){var g=window.localStorage.getItem("_pdfps");window.googletag.pubads().setTargeting("permutive",g?JSON.parse(g):[])}});
`;

const IDENTIFY_TIMEOUT = 1000;

class Permutive extends Component {
  static Head() {
    return (
      <Fragment>
        <script dangerouslySetInnerHTML={{ __html: PERMUTIVE_JS }} />
        <script
          async
          src={`https://cdn.permutive.com/${PERMUTIVE_PROJECT_ID}-web.js`}
        />
      </Fragment>
    );
  }
  static Body() {
    return null;
  }
  render() {
    return null;
  }
}

Permutive.pageView = () => {
  /*
   * TK: Send PV data
  const data = {
    page: {
      article: {
        title: ''
      }
    }
  };
  */
  const data = {};

  if ('permutive' in window) {
    window.permutive.addon('web', data);
  }
};

Permutive.identify = atid => {
  if (!atid) {
    // atid is not set - do not identify user
    return Promise.resolve();
  }
  // If the Permutive script takes too long, resolve so we're not blocking
  // other activity, e.g. sign-in flow
  const timeout = new Promise(resolve => {
    window.setTimeout(() => {
      resolve();
    }, IDENTIFY_TIMEOUT);
  });
  // Identify user using atid, see:
  // - https://support.permutive.com/hc/en-us/articles/360010090580-Syncing-User-Identities
  // - https://www.notion.so/Apartment-Therapy-Deployment-Documentation-7884b10c426c4f55a2b843b5c80a9960
  // permutive.identify returns a promise
  const identify = window.permutive.identify([
    {
      id: atid,
      tag: 'atid',
      priority: 0
    }
  ]);
  return Promise.race([identify, timeout]);
};

export default Permutive;
